export default __webpack_public_path__ + "static/media/cp1.e5ee87f3.png";